export const reCityConstants = {
	GetCities: {
		REQUEST : 'GET_NRI_CITIES_REQUEST',
		SUCCESS : 'GET_NRI_CITIES_SUCCESS',
		FAILURE : 'GET_NRI_CITIES_FAILURE'
	},
	ClearCities: 'CLEAR_NRI_CITIES'
}